import React from 'react';
import { ParametroDefinicaoDTO } from '../integracaoInterfaces';

interface DadosEspecificosProps {
    parametrosDefinicao: ParametroDefinicaoDTO[];
    valoresEspecificos: {[key: string]: string};
    setValoresEspecificos: (v: {[key: string]: string}) => void;
}

const DadosEspecificosCard: React.FC<DadosEspecificosProps> = ({ 
    parametrosDefinicao, valoresEspecificos, setValoresEspecificos 
}) => {
    const campos = parametrosDefinicao.filter(p => p.tipoParametro === 'CAMPO');

    if (campos.length === 0) return (
        <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light fw-bold">Dados Específicos</div>
            <div className="card-body">
                <div className="text-muted p-3">Nenhum dado específico necessário. Configure as credenciais na origem.</div>
            </div>
        </div>
    );

    return (
        <div className="card mb-4 shadow-sm">
            <div className="card-header bg-light fw-bold">Dados Específicos</div>
            <div className="card-body">
                <div className="row">
                    {campos.map(p => (
                        <div className="col-md-6 mb-3" key={p.id}>
                            <label className="form-label">{p.nomeParametro.replace(/_/g, ' ')}:</label>
                            <input 
                                type="text" 
                                className="form-control"
                                placeholder={`Informe ${p.nomeParametro.replace(/_/g, ' ')}`}
                                value={valoresEspecificos[p.nomeParametro] || ''}
                                onChange={e => setValoresEspecificos({...valoresEspecificos, [p.nomeParametro]: e.target.value})}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DadosEspecificosCard;